import React from "react";
import styled from "styled-components";
import { formatDate } from "../utils/dateUtils";

export const TimelineWrapper = styled.div`
  position: absolute;
  bottom: 28px;
  left: 10px;
  right: 10px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: "Inter", sans-serif;
  overflow: scroll;
`;

export const TimelineRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 1px;
  margin-bottom: 2px;
  cursor: pointer;
`;

export const YearContainer = styled.div``;

export const TimelineLabel = styled.div`
  display: flex;
  justify-content: ${({ type }) => (type === "year" ? "left" : "center")};
  font-size: ${({ type }) => (type === "year" ? "1rem" : "0.75rem")};
  font-weight: 800;
  color: #666;
  min-width: 40px;
  padding-bottom: 3px;
  padding-left: ${({ type }) => (type === "year" ? "2px" : "0px")};
`;

export const TimelineTick = styled.div`
  width: 1px;
  height: 16px;
  background: #d3d3d3;
  height: ${({ $isBoundaryTick }) => ($isBoundaryTick ? "20px" : "16px")};
  background: ${({ $isBoundaryTick }) =>
    $isBoundaryTick ? "#666" : "#d3d3d3"};
  margin-left: ${({ $isBoundaryTick }) => ($isBoundaryTick ? "2px" : "0")};
  margin-right: ${({ $isBoundaryTick }) => ($isBoundaryTick ? "2px" : "0")};
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.4);
    background: #005fcc;
  }
`;

export default function Timeline({ groupedTimestamps, onHover }) {
  const sortedYears = Object.keys(groupedTimestamps).sort();
  const sortedDaysPerYear = {};
  Object.keys(groupedTimestamps).forEach((year) => {
    sortedDaysPerYear[year] = Object.keys(groupedTimestamps[year]).sort();
  });

  return (
    <TimelineWrapper>
      <TimelineRow>
        {sortedYears.map((year, yearx) => (
          <YearContainer key={year}>
            <TimelineLabel type="year">{year}</TimelineLabel>
            <TimelineRow>
              {sortedDaysPerYear[year].map((day, dayx) => (
                <div key={day}>
                  <TimelineLabel>{formatDate(day)}</TimelineLabel>
                  <TimelineRow>
                    {groupedTimestamps[year][day].map((point, idx) => (
                      <TimelineTick
                        key={idx}
                        onMouseEnter={() => onHover(point)}
                        onMouseLeave={() => onHover(null)}
                        $isBoundaryTick={
                          idx === 0 ||
                          (idx === groupedTimestamps[year][day].length - 1 &&
                            dayx === sortedDaysPerYear[year].length - 1 &&
                            yearx === sortedYears.length - 1)
                        }
                      />
                    ))}
                  </TimelineRow>
                </div>
              ))}
            </TimelineRow>
          </YearContainer>
        ))}
      </TimelineRow>
    </TimelineWrapper>
  );
}
